import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOMeta from '@/components/base/SEOMeta';
import StructuredData from '@/components/base/StructuredData';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';
import RecommendedSection from './components/RecommendedSection';
import CTASection from './components/CTASection';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  const faqData = [
    {
      question: '樱花动漫91有哪些漫画种类？',
      answer: '樱花动漫91提供丰富的漫画分类，包括恋爱漫画、热血漫画、奇幻漫画、搞笑漫画、恐怖漫画、校园漫画、冒险漫画、悬疑漫画等，满足不同读者的阅读需求。',
    },
    {
      question: '樱花动漫91的漫画是免费的吗？',
      answer: '是的，樱花动漫91平台上的所有漫画全部免费在线观看，我们提供下拉式阅读体验，无需翻页，阅读更加流畅便捷。',
    },
    {
      question: '漫画更新频率是怎样的？',
      answer: '樱花动漫91每日更新最新漫画章节，热门连载漫画保持定期更新，确保读者能够第一时间看到最新内容。',
    },
    {
      question: '如何在手机上阅读漫画？',
      answer: '樱花动漫91采用响应式设计，适配手机、平板和电脑等多种设备。您只需使用浏览器访问，即可享受流畅的漫画阅读体验，无需下载APP。',
    },
  ];

  return (
    <>
      <SEOMeta
        title="樱花动漫91 - 漫画全集下拉式阅读，在线漫画资源大全"
        description="樱花动漫91提供漫画全集下拉式阅读体验，海量在线漫画资源，好看的漫画免费看，每日更新最新漫画章节。涵盖恋爱、热血、奇幻、搞笑、恐怖、校园、冒险、悬疑等丰富分类。"
        keywords="樱花动漫91,漫画全集,下拉式漫画,漫画阅读,在线漫画,漫画资源,好看的漫画,漫画大全,免费漫画,下拉式阅读"
        canonicalUrl="https://yinghuadongman91.com"
      />
      <StructuredData type="Organization" />
      <StructuredData type="WebSite" />
      <StructuredData
        type="FAQPage"
        faqData={faqData}
        data={{ mainEntityOfPage: { '@id': 'https://yinghuadongman91.com' } }}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />

            <CategorySection
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
            />

            <LatestUpdates category={activeCategory} />

            <PopularRanking />

            <RecommendedSection />

            <CTASection />

            <section className="py-14 bg-white" aria-labelledby="faq-heading">
              <div className="max-w-[1280px] mx-auto px-4 md:px-6">
                <h2 id="faq-heading" className="font-heading text-2xl text-foreground-950 mb-8 text-center">
                  常见问题
                </h2>
                <div className="max-w-[720px] mx-auto space-y-3">
                  {faqData.map((faq, idx) => (
                    <details
                      key={idx}
                      className="group bg-background-50 rounded-xl overflow-hidden"
                    >
                      <summary className="px-6 py-4 cursor-pointer text-foreground-950 font-medium text-sm flex items-center justify-between list-none">
                        <span>{faq.question}</span>
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-3">
                          <i className="ri-add-line group-open:hidden text-foreground-400"></i>
                          <i className="ri-subtract-line hidden group-open:block text-primary-500"></i>
                        </div>
                      </summary>
                      <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </section>
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}